import * as actionTypes from "../constants";
import * as apis from "../requests/apis";
import * as payloads from "../requests/payloads";
import { clientRequest, contentHeader } from "../requests";
import { showToast, TOAST_TYPE } from "utils/toast";

// Get Schedules
// NOTE: no more Task/Time dropdown fetching — ScheduleDto dropped that model
// entirely (see payloads.schedulePayload). GET_SCHEDULES_API's URL is
// unchanged (exact match), so the `res.data.scheduleList` + pagination
// wrapper shape is assumed unchanged too — not independently verified.
export const getSchedules = (page, pageSize, reset = false) => async (dispatch) => {
  try {
    if(reset) dispatch({ type: actionTypes.RESET_SCHEDULE });
    else dispatch({ type: actionTypes.FETCH_SCHEDULES });
    const schedulesList = await clientRequest(
      actionTypes.GET,
      `${apis.GET_SCHEDULES_API}?page=${page}&pageSize=${pageSize}`,
      null
    );
    const data = payloads.getSchedulesPayload(schedulesList.data.scheduleList);
    const pagination = payloads.getPagination(schedulesList.data);
    dispatch({
      type: actionTypes.GET_SCHEDULES_SUCCESS,
      payload: {
        data,
        pagination,
      },
    });
  } catch (err) {
    dispatch({
      type: actionTypes.GET_SCHEDULES_FAIL,
      payload: err,
    });
  }
};

// Add Schedule
export const addSchedule = (form) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.SAVING_SCHEDULE });
    const payload = payloads.schedulePayload(form);
    await clientRequest(actionTypes.POST, apis.ADD_SCHEDULE_API, payload, contentHeader);
    setTimeout(() => {
      dispatch({
        type: actionTypes.ADD_SCHEDULE_SUCCESS,
      });
    }, 2000);
  } catch (err) {
    showToast(err?.response?.data || "Failed to add schedule.", TOAST_TYPE.error);
    dispatch({
      type: actionTypes.ADD_SCHEDULE_FAIL,
      payload: err,
    });
  }
};

// Edit Schedule
export const editSchedule = (form) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.SAVING_SCHEDULE });
    const payload = payloads.schedulePayload(form);
    await clientRequest(actionTypes.POST, apis.UPDATE_SCHEDULE_API, payload, contentHeader);
    setTimeout(() => {
      dispatch({ type: actionTypes.ADD_SCHEDULE_SUCCESS });
    }, 2000);
  } catch (err) {
    showToast(err?.response?.data || "Failed to update schedule.", TOAST_TYPE.error);
    dispatch({ type: actionTypes.EDIT_SCHEDULE_FAIL, payload: err });
  }
};

// Delete Schedule
export const deleteSchedule = (form) => async (dispatch) => {
  try {
    await clientRequest(actionTypes.POST, apis.DELETE_SCHEDULE_API, { id: form.id }, contentHeader);
    dispatch({
      type: actionTypes.DELETE_SCHEDULE_SUCCESS,
      payload: form,
    });
  } catch (err) {
    showToast(err?.response?.data || "Failed to delete schedule.", TOAST_TYPE.error);
    dispatch({
      type: actionTypes.DELETE_SCHEDULE_FAIL,
      payload: err,
    });
  }
};

// Reset Schedule Pagination
export const resetSchedulePagination = () => async (dispatch) => {
  try {
    dispatch({
      type: actionTypes.RESET_SCHEDULE_PAGINATION_SUCCESS,
    });
  } catch (err) {
    dispatch({
      type: actionTypes.RESET_SCHEDULE_PAGINATION_FAIL,
    });
  }
};

// Get Advance Search
export const getAdvanceSearchSchedule = (username) => async (dispatch) => {
  try{
    dispatch({ type: actionTypes.ADVANCE_SEARCH_REQUEST_SCHEDULE });
    const res = await clientRequest(actionTypes.GET, `${apis.GET_ADVANCE_SEARCH_API}?username=${username}&searchType=schedule`);
    const data = await payloads.getSchedulesPayload(res.data);
    dispatch({
      type: actionTypes.GET_ADVANCE_SEARCH_SCHEDULE_SUCCESS,
      payload: data,
    });
  }catch(err) {
    dispatch({ type: actionTypes.GET_ADVANCE_SEARCH_SCHEDULE_FAIL, payload: err });
  }
}
